export const coalesce = <T>(value: T | null | undefined, defaultValue: T): T => {
    return value === null || value === undefined ? defaultValue : value
}
